// extracted by mini-css-extract-plugin
module.exports = {"block":"Articles_block__c0IVA","header":"Articles_header__HpGJz","list":"Articles_list__0ifDs","main":"Articles_main__XSHH6","fadeOut":"Articles_fadeOut__wLntw"};